module.exports = __webpack_public_path__ + "media/images/front/common/icon_feature-62f1948aece9a7899fcf107ef9af18a4.svg";